import { getUserCompanyList } from '@/common/js/util';
export const searchColumns = (ctx) => {
  return [
    {
      prop: 'depositCompanyNo',
      name: '公司名称',
      type: 'select',
      options: getUserCompanyList(),
      clearable: true,
      filterable: true,
      changeMethod: 'changeMethod',
      method: 'post',
    },
    {
      prop: 'depositDepartmentNo',
      name: '部门',
      type: 'select',
      options: ctx.departList,
      clearable: true,
      filterable: true,
      disabled: !ctx.queryData.depositCompanyNo,
    },
    {
      name: '申请编号',
      prop: 'applicationNo',
      type: 'input',
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
    },
    {
      name: '合同名称',
      prop: 'contractName',
      type: 'input',
    },
    {
      prop: 'customerName',
      type: 'searchTableSpec',
      name: '客户名称',
      searchType: 'customer',
      extraData: {
        // partnerTypes: 'HZHB03,HZHB01',
        companyCode: ctx.userInfo.companyCode,
        departmentCode: ctx.userInfo.departmentCode,
      },
    },
    {
      name: '审核状态',
      prop: 'auditStatus',
      type: 'select',
      placeholder: '全部',
      options: [
        { value: '01', label: '待审核' },
        { value: '02', label: '审核通过' },
        { value: '03', label: '审核驳回' },
      ],
    },
    // {
    //   name: '合同类型',
    //   prop: 'contractType',
    //   type: 'select',
    //   placeholder: '全部',
    //   options: [
    //     { value: '01', label: '租赁合同' },
    //     { value: '02', label: '物业合同' },
    //   ],
    // },
    {
      name: '申请类型',
      prop: 'applicationType',
      type: 'select',
      placeholder: '全部',
      options: [
        { value: '01', label: '退回' },
        { value: '02', label: '罚没' },
      ],
    },
  ];
};

export const defaultTableColumns = () => {
  return [
    {
      field: 'applicationNo',
      title: '申请编号',
      width: '140',
    },
    {
      field: 'contractNo',
      title: '合同编号',
      width: '140',
    },
    {
      field: 'contractName',
      title: '合同名称',
      width: '200',
    },
    {
      field: 'contractType',
      title: '合同类型',
      width: '140',
    },
    {
      field: 'customerName', //
      title: '客户名称',
      width: '140',
    },
    {
      field: 'signPartyName',
      title: '签约方',
      width: '140',
    },
    {
      field: 'applicationType',
      title: '申请类型',
      width: '140',
    },
    {
      field: 'applicationAmount',
      title: '申请金额',
      width: '140',
    },
    {
      field: 'auditStatus',
      title: '审核状态',
      width: '140',
    },
    {
      field: 'createPersonName',
      title: '申请人',
      width: '140',
    },
    {
      field: 'gmtCreate',
      title: '申请日期',
      width: '280',
    },
  ];
};
